// import { AnnouncementProvider, useAnnouncement } from "contexts/announcement";
import useAuth from "hooks/useAuth";
import useSocketIo from "hooks/useSocketIo";
import useWindowUrl from "hooks/useWindowUrl";
import { isEmpty } from "lodash";
import { useEffect, useRef } from "react";
import { Redirect, Route, useHistory } from "react-router-dom";
import { IntercomProvider } from "react-use-intercom";
import { useStore } from "store/index";
import { getDevice, getUserLocation, urlBase64ToUint8Array } from "util/utils";
import constant from "../config/constant";

const clientUrl = process.env.REACT_APP_CLIENT_URL;
const baseUrl = `${process.env.REACT_APP_API_ENDPOINT}`;

const ProtectedRoute = (props) => {
  const username = useRef(null);
  const { profile, refetchProfile } = useAuth();
  const { component: Component, ...extendedProps } = props;
  const [pageUrl] = useWindowUrl();
  const history = useHistory();
  const socketIo = useSocketIo();

  if (String(process.env.NODE_ENV).includes("dev") && 2 + 2 === 5) {
    console.log({ socketIo });
  }

  const { store, logout, login, hydrateToken } = useStore();

  useEffect(() => {
    username.current = store?.userData?.username;

    if (profile.verification.length >= 1) {
      history.replace(constant.PAGES.VERIFY_EMAIL_PASSWORD);
    }

    // eslint-disable-next-line
  }, [store, store?.loginStatus, store?.userId]);

  useEffect(() => {
    if (username.current) {
      if ("serviceWorker" in navigator) {
        let appendEnv = "";
        const isProd =
          String(process.env.NODE_ENV).toLowerCase() === "production";
        const isDev = String(process.env.NODE_ENV)
          .toLowerCase()
          .includes("dev");
        const isStaging = !isDev && !isProd;

        if (isStaging) appendEnv = "-staging";
        if (isProd) appendEnv = "-prod";
        navigator.serviceWorker.register(`${clientUrl}push${appendEnv}.js`, {
          scope: "/",
        });
        const previousStorageKey = "btm_www_push2";
        const storageKey = "btm_www_push3";
        try {
          if (previousStorageKey) localStorage?.removeItem(previousStorageKey);
        } catch (err) {}

        const webSubbedStr = localStorage?.getItem(storageKey);
        const webSubbed = webSubbedStr ? JSON.parse(webSubbedStr) : null;
        const today = new Date();
        const dayStr = today.toJSON().slice(0, 10);

        let subbing = false;
        function regSub() {
          if (webSubbed && webSubbed[dayStr]) {
          } else {
            try {
              navigator.serviceWorker.ready
                .then(function (registration) {
                  return registration.pushManager
                    .getSubscription()
                    .then(async function (subscription) {
                      // If a subscription was found, return it.
                      if (subscription) {
                        return subscription;
                      }

                      // Get the server’s public key
                      let vapidPublicKey = process.env.REACT_APP_VAPIDKEY;
                      // Chrome doesn’t accept the base64-encoded (string) vapidPublicKey yet urlBase64ToUint8Array() is defined in /tools.js
                      const convertedVapidKey =
                        urlBase64ToUint8Array(vapidPublicKey);

                      // Otherwise, subscribe the user We are not strictly honoring userVisibleOnly: we will also be sending invisible pushes, but otherwise Chrome will not allow us to setup a subscription.
                      return registration.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: convertedVapidKey,
                      });
                    });
                })
                .then(async function (subscription) {
                  // Send the subscription details to the server using the Fetch API.
                  if (username.current && !webSubbed && !subbing) {
                    const token = store.token;
                    const browserAgent = await getDevice();
                    const loc = await getUserLocation();
                    const payload = {
                      username: store.userData.username,
                      userId: store.userData.userId,
                      subscription,
                      device: {
                        ...browserAgent,
                      },
                      loc,
                    };
                    subbing = true;
                    await fetch(baseUrl + "/notifications/webpush/subscribe", {
                      method: "post",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: token,
                      },
                      body: JSON.stringify(payload),
                    })
                      .then((res) => {
                        if (username.current && res.status === 200)
                          localStorage.setItem(
                            storageKey,
                            JSON.stringify({ [dayStr]: true })
                          );
                      })
                      .catch((err) => {
                        console.log("Failed to register for web push ", err);
                      });
                  }
                });
            } catch (err) {
              console.log({ err });
            }
          }
        }

        // Let's check if the browser supports notifications
        if (!("Notification" in window)) {
          console.error("This browser does not support desktop notification");
        }

        // Let's check whether notification permissions have already been granted
        else if (Notification.permission === "granted") {
          console.log("Permission to receive notifications has been granted");
          regSub();
        }

        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== "denied") {
          Notification.requestPermission(function (permission) {
            // If the user accepts, let's create a notification
            if (permission === "granted") {
              console.log(
                "Permission to receive notifications has been granted"
              );
              regSub();
            }
          });
        }
      }
    }
    // eslint-disable-next-line
  }, [store?.token, store?.isSignedIn, store?.userData.username]);
  if (!store) return null;
  if (isEmpty(store)) return null;
  // can put a loader here
  if (store?.isLoading || !store?.isSignedIn || !store.token) return null;

  return (
    // <AnnouncementProvider>
    <HandleHistory history={history}>
      <Route
        {...extendedProps}
        render={(props) =>
          store.isSignedIn && store.token && store.userData ? (
            <IntercomProvider appId={process.env.REACT_APP_INTERCOM_TOKEN}>
              <Component
                {...props}
                // history={history}
                token={store.token}
                userData={store.userData}
                logout={() => logout()}
                login={(data) => login(data)}
                hydrateToken={hydrateToken}
                refetchProfile={refetchProfile}
              />
            </IntercomProvider>
          ) : (
            <Redirect to={`/?redirectUrl=${pageUrl}`} />
          )
        }
      />
    </HandleHistory>
    // </AnnouncementProvider>
  );
};

const HandleHistory = ({ history, children }) => {
  // const { setHistory } = useAnnouncement();
  // useEffect(() => {
  //   setHistory(history);
  //   //esling-disable-next-line
  // }, [history, setHistory]);

  return <>{children}</>;
};
export default ProtectedRoute;
